import type { ApiDashboardElement } from '@highimpact-frontend/api-types';
import type { DisplayerType } from '@highimpact-frontend/displayer-types';

import { resolveRendererTypeFromElement } from '../dashboard/widget/widgets/displayerWidget/displayerElementConsistency';

/** Minimal (legacy) displayer-shaped object for nav shell derived from element JSON. */
export function buildElementNavDisplayer(
  element: ApiDashboardElement,
  displayerId: number
): DisplayerType {
  const type = resolveRendererTypeFromElement(element);

  if (type === 'DisplayerTypeError') {
    return {
      id: displayerId,
      name: element.name,
      type: 'DisplayerTypeError',
    };
  }

  return {
    id: displayerId,
    name: element.name,
    type,
    time_range: [],
    measures: {},
    cols: {},
    query_map: [],
    intervals: [],
  };
}
